/** A part type's own page lives under the Part types tab, `/maintenance/part-types/:id`, so the sidebar keeps Maintenance highlighted. */
export function partTypePath(id: string): string {
  return `/maintenance/part-types/${id}`;
}
